// extracted by mini-css-extract-plugin
export default {"table":"ResultsTable-module__table__fedZl","button":"ResultsTable-module__button__XxaUr","conversationIcon":"ResultsTable-module__conversationIcon__5d6bi"};